import { ReactNode, useCallback, useMemo } from 'react';

import { GtmPayload } from '@gn-audio/jss-core/common/models';

import { TrackingContext } from '../contexts';

declare global {
  interface Window {
    dataLayer?: object[];
  }
}

interface Props {
  children: ReactNode;
}

export const TrackingProvider = ({ children }: Props): JSX.Element => {
  const gtmEvent = useCallback((data: GtmPayload) => {
    if (typeof window !== 'undefined') {
      if (window.dataLayer) {
        window.dataLayer.push(data);
      } else {
        console.error('GTM dataLayer is not defined.');
      }
    }
  }, []);

  const trackingContext = useMemo(() => ({ gtmEvent }), [gtmEvent]);

  return <TrackingContext.Provider value={trackingContext}>{children}</TrackingContext.Provider>;
};
